import {gql, useLazyQuery} from '@apollo/client'
import paginationLimit from '../configs/paginationLimit.json'
import {useSelector} from 'react-redux'

export const GET_PROSPECTS_LIST = gql`
  query GetProspectsList(
    $filters: ProspectFilters!
    $startIndex: Int!
    $limit: Int!
    $azureRole: String
    $sortColumn: String
    $sortDirection: String
  ) {
    prospectList(
      filters: $filters
      startIndex: $startIndex
      limit: $limit
      azureRole: $azureRole
      sortColumn: $sortColumn
      sortDirection: $sortDirection
    ) {
      totalCount
      prospects {
        fullName
        lastContactDate
        givingCapacity
        prospectType
        interestTag
        likelihoodToGive
        boardMember
        city
        contactReport
        uniqueConstituentIdentifier
        email
        preferredOutreach
        isManaged
        state
        educationSummary {
          classYear
          degreeCollegeMapping {
            college
            degree
          }
        }
      }
    }
  }
`

export default function useProspectsList() {
  const currentPage = useSelector((state) => state.currentPageNumber.value)
  const startIndex = (currentPage - 1) * paginationLimit.pagination.prospectsSegment
  const {currentTerm} = useSelector((state) => state.search.allProspectsSearch)
  const askGivePrismFilters = useSelector((state) => state.askGivePrism.filters) || {}
  const azureRole = useSelector((state) => state.superUserTenantSlice.azureRole)
  const filters = {name: currentTerm, ...askGivePrismFilters}
  const sortDirection = useSelector((state) => state.getAllProspectsData.sortDirection)
  const sortColumn = useSelector((state) => state.getAllProspectsData.sortColumn)
  const [conditionalProspectList, {data, loading, error, refetch}] = useLazyQuery(GET_PROSPECTS_LIST, {
    variables: {
      filters,
      startIndex,
      limit: paginationLimit.pagination.prospectsSegment,
      ...(azureRole ? {azureRole} : {}),
      ...(sortColumn ? {sortColumn} : {}),
      ...(sortDirection ? {sortDirection} : {})
    },
    notifyOnNetworkStatusChange: true,
    errorPolicy: 'all',
    fetchPolicy: 'network-only'
  })
  return [conditionalProspectList, {data, loading, error, refetch}]
}
